<ng-content></ng-content>
<span
  [class]="labelCssClass()"
  [attr.uistate]="state()"
  [title]="title() || labelTip() || label()"
  [UiCopy]="label()!"
  >{{ label() }}
</span>

@if (labelTip()) {
  <icon
    uiinfo
    [iconSize]="'small'"
    [iconDefinition]="ICONS.INFO"
    [title]="labelTip()"
  ></icon>
}
